(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-form"] && !Shopify.designMode) return;
  try {
    
(() => {
  const params = new URLSearchParams(window.location.search);
  if (params.get('subject') !== 'retour-stock') return;

  const subject = document.getElementById('ContactForm-subject');
  const body = document.getElementById('ContactForm-body');
  const product = params.get('product') || '';
  const url = params.get('url') || '';

  if (subject) subject.value = 'Retour en stock';

  if (body && !body.value.trim()) {
    const lines = [
      'Bonjour,',
      '',
      'Je souhaite être prévenu du retour en stock de ce produit.'
    ];

    if (product) {
      lines.push('', `Produit : ${product}`);
    }

    if (url) {
      lines.push(`Lien : ${url}`);
    }

    body.value = lines.join('\u000A');
  }
})();

  } catch(e) { console.error(e); }
})();
})();
